<style scoped>
.svgContent {
  width: 100%;
  text-align: center
}
.icon-search {
  position: fixed;
  top: 120px;
  left: 2px;
  z-index: 999;
}
.searchBox {
  position: fixed;
  width: 200px;
  padding: 10px;
  background-color: #fff;
  height: auto;
  top: 100px;
  left: 0px;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 100;
}
.icon-close {
  position: absolute;
  top: 20px;
  left: 198px;
  cursor: pointer;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
}
.lineRemark{
  position: fixed;
  right: 50px;
  top: 100px;
  width: 300px;
}
.lineOpen{
  margin: 0 auto;
  position: relative;
  outline: 0;
  width: 200px;
  top: 300px;
  background-color: rgba(0,0,0,.5);
  border: 0;
  border-radius: 6px;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 10px;
}
</style>

<template>
    <div>
        <header v-title data-title="城市地铁开通历程图"/>

        <div class="icon-search" v-show="!searchBoxShow">
            <Button type="warning" shape="circle" icon="ios-search" @click="switchSearchBox(false)"></Button>
        </div>
        <transition name="fade">
          <div class="searchBox" v-show="searchBoxShow">
            <div class="icon-close" @click="switchSearchBox(true)">
              <Icon type="md-close" :size="18" color="gray" />
            </div>

            <Row class="text-center">
              <ButtonGroup size="small">
                <Button :type="pageType===1?'primary':'default'" @click="handleChangePageType(1)">开通历程</Button>
                <Button :type="pageType===2?'primary':'default'" @click="handleChangePageType(2)">线路详情</Button>
              </ButtonGroup>
            </Row>
            <Divider style="margin: 10px 0;"/>
            <Row class="p-b-10">
              <i-col span="8" class="p-l-5 p-t-5"><h3>城市：</h3> </i-col>
              <i-col span="16">
                <Select v-model="chooseCity" prefix="ios-home" @on-change="handleChangeCity">
                  <OptionGroup v-for="(group,index) in cityGroup" :key="index" :label="group">
                      <Option v-for="city in citys.filter(x=>x.group === group)" :value="city.code" :key="city.code">{{ city.name }}</Option>
                  </OptionGroup>
                </Select>
              </i-col>
            </Row>

            <template v-if="pageType===1">
              <Timeline class="m-l-10">
                <TimelineItem color="green">
                    <Icon type="ios-trophy" slot="dot"></Icon>
                    <span>地铁开通日期</span>
                    <Button shape="circle" type="info" ghost size="small" :icon="pause? 'md-pause' : 'md-play'" class="m-l-5" @click="handlePause"></Button>
                </TimelineItem>
                <TimelineItem v-for="(time,index) in showTimeList" :key="index" :color="currentChoosetTime===time?'red':'blue'">
                  <a @click="handleClickTime(time)"  :class="currentChoosetTime===time?'active':''">{{time}}</a>
                </TimelineItem>
              </Timeline>
              <Page :current="currentPageNumber" :page-size="10" :total="timeList.length" simple @on-change="handlePageChange"/>
            </template>

            <template v-else>
              <P v-for="(line,index) in linePoint" :key="index">
                <a :class="currentChooseLine===line?'active':''" @click="handleChooseLine(line)">{{line.name}}</a>
              </P>
            </template>

          </div>
        </transition>

        <div class="ivu-modal-wrap ivu-modal-no-mask">
          <div v-if="currentChoosetTime!=='' && pageType === 1"  class="lineOpen">
            <h2 class="text-white">{{currentChoosetTime}}</h2>
            <Row class="text-white">
              <i-col span="6">开通：</i-col>
              <i-col span="18">
                <p v-for="(content,index) in computedTimeContent(currentChoosetTime)" :key="index">
                  {{content}}
                </p>
              </i-col>
            </Row>
          </div>
        </div>

        <Card v-if="currentChooseLine!==null && pageType === 2" class="lineRemark">
          <h2 class="text-orange text-center">{{currentChooseLine.name}}</h2>
          <Row>
            <i-col span="7">线路长度：</i-col>
            <i-col span="17">{{currentChooseLine.length}} KM</i-col>
          </Row>
          <Row>
            <i-col span="7">运行时间：</i-col>
            <i-col span="17">{{currentChooseLine.runTime}}</i-col>
          </Row>
          <Row>
            <i-col span="7">运营机构：</i-col>
            <i-col span="17">{{currentChooseLine.operator}}</i-col>
          </Row>
          <Row>
            <i-col span="7">车站数量</i-col>
            <i-col span="17">{{currentChooseLine.stationNumber}} 站</i-col>
          </Row>
          <Row>
            <i-col span="7">车型：</i-col>
            <i-col span="17">{{currentChooseLine.group}}</i-col>
          </Row>
          <Row>
            <i-col span="7">日客运量：</i-col>
            <i-col span="17">{{currentChooseLine.remark}}</i-col>
          </Row>
        </Card>

        <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
            <div>地图加载中...</div>
        </Spin>
    </div>
</template>

<script>
import { mapOperation } from '@/utils/mapOperation'

import { getAllByCityCode } from '@/api/rim'
import { getStationOpenStatistics } from '@/api/station'
import { ParseDate } from '@/utils/dataformat'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  data () {
    return ({
      pageType: 1,
      svgHtml: '',
      chooseCity: '', // 默认选中城市
      citys: this.$store.state.main.mapCitys,
      cityGroup: [],

      spinShow: false,
      searchBoxShow: true,
      linePoint: [],
      pageSize: 10,

      timeList: [],
      query: {
        startDate: '',
        endDate: ''
      },
      total: 0,
      currentPageNumber: 0,
      showTimeList: [], // 提供分页显示的时间轴
      pause: false,
      pageDestroyed: false,
      currentChoosetTime: '',
      stationStatistic: [],
      currentChooseLine: null
    })
  },
  mounted () {
    this.formatCityData()
    this.initPageData()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height = document.documentElement.clientHeight - 90 + 'px'
    })
  },
  methods: {
    formatCityData () {
      this.chooseCity = this.citys[this.citys.length - 1].code
      let group = []
      this.citys.forEach(element => {
        if (group.indexOf(element.group) === -1) {
          group.push(element.group)
        }
      })
      this.cityGroup = group.sort()
    },
    initPageData () {
      const data = { cityCode: this.chooseCity }
      getAllByCityCode(data).then(res => {
        this.linePoint = res
      })

      this.initMap()
      this.loadStationOpenData()
    },
    handleChangePageType (pageType) {
      this.pause = false
      this.pageType = pageType
    },
    loadStationOpenData () {
      getStationOpenStatistics({ cityCode: this.chooseCity }).then(res => {
        this.stationStatistic = res.sort(function (a, b) {
          return a.openDate > b.openDate ? 1 : -1
        })

        this.stationStatistic.forEach(element => {
          if (this.timeList.indexOf(element.openDate) === -1) {
            this.timeList.push(element.openDate)
          }
        })

        this.currentPageNumber = 1
        this.formatShowTimeList()
      })
    },
    handleChangeCity (type) {
      this.currentChoosetTime = ''
      this.currentChooseLine = null
      this.chooseCity = type
      this.pause = false
      this.timeList = []
      this.initPageData()
    },
    handleClickTime (time) {
      if (this.currentChoosetTime === time) { return }

      this.currentChoosetTime = time
      this.pause = false
    },
    handlePause () {
      this.pause = !this.pause
      if (this.pause) {
        this.autoReplayTime()
      }
    },
    autoReplayTime () {
      let _this = this
      setTimeout(() => {
        if (_this.pause && !_this.pageDestroyed) {
          let startIndex = _this.timeList.indexOf(_this.currentChoosetTime) + 1

          if (startIndex === _this.timeList.length) {
            _this.currentChoosetTime = _this.timeList[0]

            // 自动回到第一页
            _this.currentPageNumber = 1
            _this.formatShowTimeList()
          } else {
            if (startIndex > _this.currentPageNumber * _this.pageSize - 1) { // 自动下一页
              _this.currentPageNumber += 1
              _this.formatShowTimeList()
            }
            _this.currentChoosetTime = _this.timeList[startIndex]
          }

          _this.autoReplayTime()
        }
      }, 1500)
    },
    computedTimeContent (time) { // 显示文本， 地铁开通内容
      let timeContent = []

      // 可能是同一时间，开通多条线路
      const timeInfo = this.stationStatistic.filter(x => x.openDate === time)
      timeInfo.forEach(element => {
        const assetName = element.assetName.substr(element.assetName.indexOf('铁') + 1)

        let number = ''
        if (this.stationStatistic.filter(x => x.assetId === element.assetId).length > 1) {
          number = element.issue + '期'
        }

        timeContent.push(assetName + number)
      })

      return timeContent
    },
    formatShowTimeList () { // 分页格式化需要显示的时间列表
      this.showTimeList = []
      let startIndex = (this.currentPageNumber - 1) * this.pageSize

      for (let index = startIndex; index < startIndex + this.pageSize; index++) {
        if (this.timeList.length > index) {
          this.showTimeList.push(this.timeList[index])
        }
      }
    },
    handlePageChange (page) {
      this.currentPageNumber = page
      this.pause = false
      this.formatShowTimeList()
    },
    changeSearchDate () {
      this.timeList = []
      this.pause = false
      let startDate = ParseDate(this.query.startDate)
      let endDate = ParseDate(this.query.endDate)

      this.stationStatistic.forEach(element => {
        if (this.timeList.indexOf(element.openDate) < 0) {
          if (startDate === '' && endDate === '') { // 还原全部的时间段
            this.timeList.push(element.openDate)
          } else if (startDate !== '' && endDate !== '') { // 有开始和结束日期
            if (element.openDate >= startDate && element.openDate <= endDate) {
              this.timeList.push(element.openDate)
            }
          } else if (startDate !== '' && endDate === '') { // 只有开始日期
            if (element.openDate >= startDate) {
              this.timeList.push(element.openDate)
            }
          } else if (startDate === '' && endDate !== '') { // 只有结束日期
            if (element.openDate <= endDate) {
              this.timeList.push(element.openDate)
            }
          }
        }
      })

      this.currentPageNumber = 1
      this.formatShowTimeList()
    },
    switchSearchBox (show) {
      this.searchBoxShow = !show
    },
    handleChooseLine (line) {
      if (this.currentChooseLine !== line) {
        this.currentChooseLine = line
        this.handleMapGetCenter(line)
      }
    }
  },
  watch: {
    currentChoosetTime (val) {
      // 获取需要显示的全部线路ID
      let showAssetList = []
      this.stationStatistic.forEach(element => {
        if (element.openDate <= val) {
          showAssetList.push(element)
        }
      })

      let showStationList = []
      showAssetList.forEach(element => {
        showStationList = showStationList.concat(element.stations.split(','))
      })

      this.grayMapLines(showAssetList, showStationList)
    }
  },
  destroyed () {
    // 页面销毁后， 不再继续执行自动播放
    this.pageDestroyed = true
  }
}
</script>
